const updateHreflangTags = (currentPath: string) => {
  // Remove existing hreflang tags
  const existingHreflangs = document.head.querySelectorAll('link[rel="alternate"][hreflang]');
  existingHreflangs.forEach(tag => tag.remove());

  // Get the path without language prefix
  const pathParts = currentPath.split('/');
  const pathWithoutLang = pathParts.slice(2).join('/');
  
  // Base URL
  const baseUrl = window.location.origin;
  
  // Add hreflang tags for both languages
  const languages = ['en', 'de'];
  languages.forEach(lang => {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = lang;
    link.href = `${baseUrl}/${lang}/${pathWithoutLang}`;
    document.head.appendChild(link);
  });

  // Add x-default hreflang
  const xDefaultLink = document.createElement('link');
  xDefaultLink.rel = 'alternate';
  xDefaultLink.hreflang = 'x-default';
  xDefaultLink.href = `${baseUrl}/en/${pathWithoutLang}`;
  document.head.appendChild(xDefaultLink);
};

export const updateHtmlLang = (lang: string) => {
  document.documentElement.setAttribute('lang', lang);
  updateHreflangTags(window.location.pathname);
};
